module.exports = __webpack_public_path__ + "static/media/pinBGreen.e6e3a4b3.svg";